import { CareerId } from '@common/const/catalog/career';
import { AdminRoutePath } from 'src/entities/adminRoute';
import { generateAdminPath } from 'src/app/shared/utils/generateAdminPath';
import { MessagesSidebarSection } from './components/customSections/messages';
import { ModerationVacanciesSidebarItem } from './components/customSections/moderationVacancies';
import { ProcessingAndReviewsSidebarItem } from './components/customSections/processingAndReviews';
import { SidebarSectionProps } from './components/section/model';

export const sidebarConfig: SidebarSectionProps[] = [
  {
    component: MessagesSidebarSection,
  },
  {
    title: 'Скорость ответа',
    href: generateAdminPath(AdminRoutePath.ResponseDelay),
  },
  {
    title: 'Вакансии (метч)',
    href: generateAdminPath(AdminRoutePath.Vacancies),
  },
  {
    title: 'Модерация',
    isExpanded: true,
    sectionItems: [
      {
        component: ModerationVacanciesSidebarItem,
      },
      {
        title: 'Няни',
        href: generateAdminPath(AdminRoutePath.ModerationClientPatronage, { queryParams: { careerId: CareerId.Nanny } }),
      },
      {
        title: 'Сиделки',
        href: generateAdminPath(AdminRoutePath.ModerationClientPatronage, { queryParams: { careerId: CareerId.Nurse } }),
      },
      {
        title: 'Домработницы',
        href: generateAdminPath(AdminRoutePath.ModerationClientPatronage, { queryParams: { careerId: CareerId.Housekeeper } }),
      },
      {
        title: 'Репетиторы',
        href: generateAdminPath(AdminRoutePath.ModerationClientPatronage, { queryParams: { careerId: CareerId.Tutor } }),
      },
      {
        component: ProcessingAndReviewsSidebarItem,
      },
    ],
  },
  {
    title: 'Все специалисты',
    href: generateAdminPath(AdminRoutePath.Specialists),
  },
  {
    title: 'Все наниматели',
    href: generateAdminPath(AdminRoutePath.Employers),
  },
  {
    title: 'Промокоды',
    href: generateAdminPath(AdminRoutePath.Promocodes),
  },
  {
    title: 'Сервис',
    isExpanded: true,
    sectionItems: [
      {
        title: 'Блоки',
        href: generateAdminPath(AdminRoutePath.Blocks),
      },
      {
        title: 'Страницы',
        href: generateAdminPath(AdminRoutePath.RoutesMeta),
      },
      {
        title: 'Настройки',
        // TODO add href
        href: '#',
      },
      {
        title: 'Кеширование',
        href: generateAdminPath(AdminRoutePath.ServiceCaching),
      },
      {
        title: 'Подписки',
        href: generateAdminPath(AdminRoutePath.Subscriptions),
      },
      {
        title: 'Оплаты',
        href: generateAdminPath(AdminRoutePath.Invoices),
      },
      {
        title: 'Сторонние API',
        href: generateAdminPath(AdminRoutePath.ThirdPartyApi),
      },
    ],
  },
];
